import { AdjustmentType } from '@weareopenr/types';

export const formatPrice = (price: number) =>
  new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(price);

// Formats a value into a price string, e.g '0.2' becomes 'GBP 0.20', split at ' ', returning '+0.20'
export const formatPriceValue = (price: number) => {
  const value = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', currencyDisplay: 'code' })
    .format(Math.abs(price))
    .split(/(\s+)/)
    .at(-1)
    .trim();
  return price < 0 ? `-${value}` : `+${value}`;
};

export const formatAdjustmentValue = (adjustment: { type: AdjustmentType; value?: number }): string => {
  const formatted = formatPriceValue(adjustment.value);
  return adjustment.type === AdjustmentType.PERCENTAGE ? `${formatted}%` : formatted;
};
